module.exports = __webpack_public_path__ + "static/media/SteamIronsbanner.3bce3dcc.jpg";